import "../../CommonImports";
import "../../Core/core.css";
import "./Menu.css";
import "./MenuButton.css";
import * as React from "react";
import * as Resources from '../../Resources.Widgets';
import { MenuButton } from "./MenuButton";
export class MoreButton extends React.Component {
    constructor() {
        super(...arguments);
        this.menuButton = React.createRef();
        this.expand = () => {
            if (this.menuButton.current) {
                this.menuButton.current.expand();
            }
        };
        this.collapse = () => {
            if (this.menuButton.current) {
                this.menuButton.current.collapse();
            }
        };
    }
    render() {
        return (React.createElement(MenuButton, Object.assign({ ariaLabel: Resources.MoreActions, hideDropdownIcon: true, iconProps: { iconName: "MoreVertical" }, ref: this.menuButton, subtle: true, tooltipProps: { text: Resources.MoreActions } }, this.props)));
    }
    focus() {
        if (this.menuButton.current) {
            this.menuButton.current.focus();
        }
    }
    setTabIndex(index) {
        if (this.menuButton.current) {
            this.menuButton.current.setTabIndex(index);
        }
    }
}
